import { render, staticRenderFns } from "./OfferGroups.vue?vue&type=template&id=29424663&scoped=true"
import script from "./OfferGroups.vue?vue&type=script&lang=ts"
export * from "./OfferGroups.vue?vue&type=script&lang=ts"
import style0 from "./OfferGroups.vue?vue&type=style&index=0&id=29424663&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29424663",
  null
  
)

export default component.exports